import CryptoJS from 'crypto-js';

// Mirrors the backend's Node `crypto.createDecipheriv('aes-128-cbc', secretKey, iv)` —
// same raw 16-byte UTF-8 key/IV (no passphrase-based key derivation), CBC mode, PKCS7 padding.
export const decryptEIN = (cipherHex) => {
  if (!cipherHex) return '';
  try {
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_EIN_CIPHER_SECRET);
    const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_EIN_CIPHER_IV);
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(cipherHex) }, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    // The backend pads the plaintext to a fixed block length with filler bytes (e.g.
    // trailing NUL bytes) that don't form valid standard PKCS7 padding, so crypto-js's
    // Pkcs7 unpad doesn't strip them — they survive as invalid/non-printable trailing
    // bytes (rendered as tofu boxes in the UI). An EIN is only digits and a dash, so
    // just take the leading run of valid EIN characters and discard everything after.
    const decodedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decodedText.match(/^[0-9-]+/)?.[0] || '';
  } catch (error) {
    // Malformed ciphertext or a misconfigured key/IV — fall back to an empty EIN
    // rather than throwing, so the field just opens blank for the user to re-enter.
    return '';
  }
};

export const maskEIN = (ein) => (ein ? `XX-XXXX${ein.slice(7, 10)}` : '');

// Formats raw EIN input as the user types: strips non-digits, caps at 9 digits, inserts the dash.
export const formatEIN = (value) => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 9);
  return digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
};
